export default __webpack_public_path__ + "static/media/book_int_delete.5fe82150.mp3";